import {
	getPlatform,
	getLogname,
	getSourceId,
	getWexinBrowser,
	getUserMobile,
	getUserToken
} from '@/utils/system.js'

export default {
	namespaced: true,
	state: () => {

		return {
			// 设备类型
			userPlatform: getPlatform(),  	// 1: adroid , 0: ios,  2: windows
			userIp: '',											// 用户 IP
			mobile: getUserMobile(),				// 用户手机号
			token: getUserToken(),					// 用户token
			wexinBrowser: getWexinBrowser(),  // 
			logname: getLogname(),
			sourceId: getSourceId()
		};
	},
	getters: {},
	mutations: {
		setPlatform(state, v) {
			state.userPlatform = v
		},
		setUserIP(state, v) {
			state.userIp = v
			sessionStorage.setItem('userIp', v)

		},	
		setWexinBrowser(state,v){
			state.wexinBrowser = v
		},
		setUserLogname(state, v) {
			state.logname = v
			sessionStorage.setItem('logname', v)
		},
		setUserSourceId(state, v) {
			state.sourceId = v
			sessionStorage.setItem('sourceId', v)
		},
		setUserToken(state, v) {
			state.token = v
			sessionStorage.setItem('token', v)
		},
		setUserMobile(state, v) {
			state.mobile = v
			sessionStorage.setItem('mobile', v)
		},
	},
	actions: {},
};
